import { useRef, useState, useEffect, useContext } from "react";
import AuthContext from "./context/AuthProvider";
import { Spinner } from "react-bootstrap";
import { axiosAuth } from "./api/axios";
const RESET_PASSWORD_URL = "/auth/users/reset_password/";

const ResetPassword = () => {
  //const { setAuth } = useContext(AuthContext);
  const emailRef = useRef();
  const errRef = useRef();

  const [email, setEmail] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    emailRef.current.focus();
    document.body.classList.add("accountBodyColor");

    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    setLoading(true);
    const controller = new AbortController();
    const userEmail = {
      email: email,
    };
    try {
      const response = await axiosAuth.post(RESET_PASSWORD_URL, userEmail);
      if (isMounted) {
        setEmail("");
        setSuccess(true);
      }
    } catch (err) {
      console.log(err.response);
      if (!err?.response) {
        setErrMsg("אין גישה לשרת.");
      } else if (err.response?.status === 400) {
        setErrMsg("חסרים או שם המשתמש או הסיסמה");
      } else if (err.response?.status === 401) {
        setErrMsg("אין לך הרשאה מתאימה.");
      } else {
        setErrMsg("הכניסה למערכת נכשלה.");
      }
      errRef.current.focus();
    }
    setLoading(false);
  };
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">
            תהליך איפוס הסיסמה בביצוע, המתן עד סיום הפעולה.
          </h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {success ? (
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center", // This centers the text inside elements
              }}
            >
              <h3 style={{ color: "white" }}>
                נא לבדוק את תיבת המייל שלך, ולחץ על הקישור
              </h3>{" "}
              <h5 style={{ color: "white" }}>
                {" "}
                במקרה שלא מצאת את הדואר בתיבת המייל הנכנס, אנא בדוק בתיקיית ה
                spam או הזבל.
              </h5>
              <p>
                <br />
                <br />
                <a href="/">דף הבית</a>
              </p>
            </section>
          ) : (
            <section
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                ref={errRef}
                className={errMsg ? "errmsg" : "offscreen"}
                aria-live="assertive"
              >
                {errMsg}
              </p>
              <h1>איפוס סיסמה</h1>
              <form className="accountForm" onSubmit={handleSubmit}>
                <label htmlFor="email">דואר אלקטרוני:</label>
                <input
                  type="email"
                  id="email"
                  ref={emailRef}
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  required
                />

                <button>איפוס</button>
              </form>
              <p className="bold-text">
                לא רשום במערכת?
                <br />
                <span
                  className="line"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/*put router link here*/}
                  <a href="/register">הרשמה</a>
                </span>
              </p>
              <p className="bold-text">
                נרשמת בעבר?
                <br />
                <span
                  className="line"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/*put router link here*/}
                  <a href="/login">כניסה</a>
                </span>
              </p>
            </section>
          )}
        </div>
      </>
    );
  }
};

export default ResetPassword;
